<template>
  <div class="container mt-4">
    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2 p-1 ">
      <h2 class="mb-0 main-title">Categories</h2>
      <div class="d-flex align-items-center gap-2">
        <button class="btn btn-md btn-primary fs-11 fw-normal text-white" @click="openCreateModal('createModal')">
          Add New Category
        </button>
        <button type="button" class="btn btn-md btn-outline-primary fs-11 fw-normal text-primary hover-white"> <i
            class="fa fa-list fs-11 text-primary hover-white "></i> Categories List</button>
      </div>
    </div>
    <div class="filters-wrapper">
      <div class="filters-bar" id="filtersBar"></div>
      <button @click="resetAllFilters" class="btn btn-sm btn-outline-danger reset-btn fs-12 hover-white">
        <span class="material-symbols-outlined fs-13">undo</span> Reset
      </button>
    </div>

    <!-- Dropdown Template -->
    <div id="genericFilterDropdownTemplate" style="display: none;">
      <div class="generic-filter-dropdown">
        <div class="dropdown-header">
          <input type="text" class="filter-search-input" placeholder="Search...">
        </div>
        <div class="dropdown-body filter-options-container"></div>
        <div class="dropdown-footer">
          <button class="filter-clear-btn">Clear</button>
          <button class="filter-apply-btn">Apply</button>
        </div>
      </div>
    </div>
    <div class="card p-1 bg-white">


      <!-- Modal with CreateCategory inside slot -->
      <FormModal ref="createModal" title="Create New Category" id="create_category_form_modal">
        <CreateCategory @click="f" ref="CreateCategoryForm" @created="onCreated"
          @close="closeCreateModal('createModal')" />
      </FormModal>



      <!-- Loading State -->
      <LoadingBar v-if="loading" message="Loading Categories..." />

      <!-- categories Table -->
      <div v-else class="table-wrapper">
        <ListTable>
          <colgroup>
            <!-- <col style="width: 8%"> -->
            <col style="width: 44%">
            <col style="width: 44%">
            <col style="width: 10%">
          </colgroup>

          <thead>
            <tr>
              <!-- <th>SR#</th> -->
              <th @click="sortBy('name')" class="sortable">
                Category <i :class="getSortIcon('external_id')"></i>
              </th>

              <th @click="sortBy('description')" class="sortable">
                Description <i :class="getSortIcon('description')"></i>
              </th>

              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="category in categories" :key="category.external_id">
              <!-- <td>
                {{ index + 1 }}
              </td> -->
              <td>
                <div class="mb-0">
                  {{ category.name }}
                </div>
                <div class="mt-0">
                  <small class="text-muted">#{{ category.external_id }}</small>
                </div>
              </td>
              <td>{{ $limit(category.description, 50) }}</td>
            <td class="text-center">
                <TableActionDropdown style="margin-right: 30px;">
                
                  <li>
                    <a class="dropdown-item" @click.prevent="editRow(category)">
                      <i class="fa fa-pencil text-primary"></i>
                      <span>Edit</span>
                    </a>
                  </li>
                    <hr class="dropdown-divider" />
               

                  <li>
                    <a class="dropdown-item item-danger" @click.prevent="deleteRow(category)">
                      <i class="fa fa-trash"></i>
                      <span>Delete</span>
                    </a>
                  </li>
                </TableActionDropdown>

              </td>
            </tr>
            <tr v-if="categories.length === 0">
              <td colspan="3" class="text-center">No categories found</td>
            </tr>

          </tbody>
        </ListTable>

      </div>

      <!-- Pagination -->
      <Pagination :pagination="pagination" @page-change="changePage" />

    </div>
  </div>
 <FormModal ref="editModal" title="Edit Category" id="category_edit_modal">
    <EditCategory
      v-if="selectedCategoryId"
      :key="selectedCategoryId"
      :categoryId="selectedCategoryId"
      @updated="onUpdated"
      @close="closeEditModal"
    />
  </FormModal>
  <ConfirmDeleteModal
  v-model="showDeleteModal"
  title="Delete Category"
  :item-name="deletingCategory?.name"
  :loading="deleting"
  @confirm="confirmDelete"
/>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'
import Pagination from '@/components/utils/PaginationBar.vue'
import LoadingBar from '@/components/utils/LoadingBar.vue'
import FormModal from '@/components/utils/FormModal.vue'
import CreateCategory from '@/views/Asset/Category/CreateCategory.vue'
import ListTable from '@/components/utils/ListTable.vue'
import TableActionDropdown from '@/components/TableActionDropdown.vue'
import EditCategory from '@/views/Asset/Category/EditCategory.vue'
import ConfirmDeleteModal from '@/components/utils/ConfirmDeleteModal.vue'
export default {
  name: 'categoryList',
  components: {
    Pagination,
    LoadingBar,
    FormModal,
    CreateCategory,
    ListTable,
    TableActionDropdown,
    EditCategory,
     ConfirmDeleteModal
  },
  data() {
    return {
      categories: [],
      pagination: {
        total_rows: 0,
        per_page: 20,
        current_page: 1,
        total_pages: 1
      },
      loading: false,
      filteredData: [],
      currentFilters: {},
      sortColumn: 'name',
      sortOrder: 'asc',
      selectedCategory: null,
       showDeleteModal: false,
      deletingCategory:    null,
      deleting:        false,
    }
  },
  computed: {

    // Sorted data
    sortedData() {
      let result = [...this.filteredData];

      if (this.sortColumn) {
        result.sort((a, b) => {
          let valA = a[this.sortColumn];
          let valB = b[this.sortColumn];

          if (valA === undefined || valA === null) valA = '';
          if (valB === undefined || valB === null) valB = '';

          if (this.sortColumn === 'id') {
            valA = parseInt(String(valA).replace('#', '')) || 0;
            valB = parseInt(String(valB).replace('#', '')) || 0;
          }

          if (typeof valA === 'string') valA = valA.toLowerCase();
          if (typeof valB === 'string') valB = valB.toLowerCase();

          if (valA < valB) return this.sortOrder === 'asc' ? -1 : 1;
          if (valA > valB) return this.sortOrder === 'asc' ? 1 : -1;
          return 0;
        });
      }

      return result;
    },
  },
  mounted() { //doc read
    // alert(localStorage.getItem('user_token'));
    this.fetchList()

    this.$nextTick(() => {
      setTimeout(() => {
        this.initFilters();
      }, 100);
    });
  },
  methods: {
    openCreateModal(ref) {
      this.$refs[ref].showModal()

    },

    closeCreateModal(ref) {
      this.$refs[ref].closeModal()
    },

    async onCreated() {
      this.pagination.current_page = 1
      await this.fetchList()
    },
    async fetchList() {
      this.loading = true

      const result = await form_api_submit({
        url: 'asset/category/list',
        method: 'GET',
        data: {
          page: this.pagination.current_page,
          name: this.currentFilters?.name || '',
          id: this.currentFilters?.id || '',
        },
        show_success_toast: false,
        show_error_toast: true,
        remove_pre_toasts: false
      })

      if (result.success) {
        console.log(result);
        this.categories = result.data.list
        this.pagination = result.data.pagination
      }

      this.loading = false
    },

    changePage(page) {
      if (page < 1 || page > this.pagination.total_pages) return
      this.pagination.current_page = page
      // alert(this.pagination.current_page);
      this.fetchList()
    },
    initFilters() {
      if (typeof $ === "undefined" || typeof GenericFilterManager === "undefined") return;

      this.filterManager = new GenericFilterManager({
        containerId: "filtersBar",
        filters: [
          {
            key: "id",
            label: "ID",
            type: "input",
            placeholder: "Filter by ID"
          },
          {
            key: "name",
            label: "Name",
            type: "input",
            placeholder: "Filter by Name"
          }
        ],
        onFilterChange: (filters) => {
          this.applyFilters(filters);
        }
      });
    },
    applyFilters(activeFilters) {
      this.currentFilters = { ...activeFilters };
      this.pagination.current_page = 1;
      this.fetchList();
    },
    resetPagination() {
      this.pagination.current_page = 1;
      this.fetchList();
    },
    resetAllFilters() {
      if (this.filterManager) {
        this.filterManager.clearAllFilters();
      }
      this.filteredData = [...this.categories];
      this.sortColumn = 'name';
      this.sortOrder = 'asc';
      this.currentFilters = {}; // Also clear current filters
      this.resetPagination();
    },
    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortOrder = 'asc';
      }
      this.resetPagination(); // Reset to first page when sorting changes
    },

    getSortIcon(column) {
      if (this.sortColumn !== column) {
        return 'fas fa-sort text-muted';
      }
      return this.sortOrder === 'asc' ? 'fas fa-sort-up text-primary' : 'fas fa-sort-down text-primary';
    },

  editRow(row) {
      this.selectedCategoryId = row.external_id
      
      this.$nextTick(() => {
        if (this.$refs.editModal) {
          this.$refs.editModal.showModal()
        }
      })
    },

    closeEditModal() {
      if (this.$refs.editModal) {
        this.$refs.editModal.closeModal()
      }
      this.selectedCategoryId = null
    },

    async onUpdated() {
      this.closeEditModal()
      await this.fetchList() // Your existing fetch method
    },
       deleteRow(category) {
      this.deletingCategory = category
      this.showDeleteModal = true
    },

    async confirmDelete() {
      this.deleting = true
      try {
        const result = await form_api_submit({
          url: `asset/category/delete/${this.deletingCategory.id}`,
          method: 'POST',
          show_success_toast: true,
          show_error_toast: true,
        })
        if (result.success) {
          this.showDeleteModal = false
          this.deletingCategory = null
          this.fetchList()
        }
      } finally {
        this.deleting = false
      }
    },

  
  }
}
</script>

<style scoped>
.page-link {
  cursor: pointer;
}

.page-item.active .page-link {
  background-color: #667eea;
  border-color: #667eea;
}

img {
  object-fit: cover;
}
</style>